// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/shinri/AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ShogiPlayer.is_run_mode_view_mode .ShogiPlayerWidth .OpDisabledBlock{z-index:2}.ShogiPlayer.is_run_mode_view_mode .is_layer_on .OpDisabledBlock{background:rgba(0,209,178,.5)}", ""]);
// Exports
module.exports = exports;
